import {SettingsRepository} from "../SettingsRepository.js";

import {CookieJar} from "../../lib/CookieJar.js";

const API_KEY_COOKIE_NAME = 'api_key';
const CUSTOMER_SOURCE_COOKIE_NAME = 'customer_source_key';
const CUSTOMER_SOURCE_NAME_COOKIE_NAME = 'customer_source_name';
const DEFAULT_WORKSPACE_ID_COOKIE_NAME = 'default_workspace_id';

export class CookieSettingsRepository extends SettingsRepository {

    /**
     * @type {CookieJar}
     * @private
     */
    _cookieJar = new CookieJar();

    /**
     *
     * @param {CookieJar} cookieJar
     */
    constructor(cookieJar=null) {
        super();
        this._cookieJar = cookieJar ? cookieJar : new CookieJar();
    }

    get() {
        if (!this._cookieJar.has(CUSTOMER_SOURCE_COOKIE_NAME) || !this._cookieJar.has(API_KEY_COOKIE_NAME)) {
            throw new Error('No settings found');
        }
        return {
            apiKey: this._cookieJar.get(API_KEY_COOKIE_NAME),
            customerSource: this._cookieJar.get(CUSTOMER_SOURCE_COOKIE_NAME),
            customerSourceName: this._cookieJar.get(CUSTOMER_SOURCE_NAME_COOKIE_NAME),
            defaultWorkSpaceId: this._cookieJar.get(DEFAULT_WORKSPACE_ID_COOKIE_NAME),
        };
    }


    save(settings) {
        this._cookieJar.set(API_KEY_COOKIE_NAME, settings.apiKey);
        this._cookieJar.set(CUSTOMER_SOURCE_COOKIE_NAME, settings.customerSource);
        this._cookieJar.set(CUSTOMER_SOURCE_NAME_COOKIE_NAME, settings.customerSourceName);
        this._cookieJar.set(DEFAULT_WORKSPACE_ID_COOKIE_NAME, settings.defaultWorkSpaceId);
    }
}